import React from 'react';
import { Column, Button } from '@codeparva/ui-components-library';
import { TopBarTypes } from './topBarTypes';
import { Link } from 'gatsby';
import { FontAwesomeIcon } from '../../../../utilities/iconLoader/FontAwesomeIcon';
import { useThemeContext } from './hooks/themeContext';
import { HEADER_ICON_SIZES } from '../Header/constants';
import {
  CommonFacilityDetailsHelper,
  GenericFacilityDetails,
} from './helpers/TopBarFacilityDetailsHelper';
import { useWindowDimensions } from '../../../../utilities/Dimensions';
import { desktopscreensize } from '../../../../utilities/constants';

export const renderPayRentButton = (
  locationtype: string,
  buttonsConfig: TopBarTypes.TButtonsConfig,
  variant: string
) => {
  const { width } = useWindowDimensions();
  const { show, showOnTouchDevice, url } = buttonsConfig;
  const currTheme = useThemeContext();
  const selectTopBarFacilityDetailsTheme = () => {
    switch (currTheme) {
      case 'light':
        return 'light';
      case 'dark':
        return 'dark';
      default:
        return 'light';
    }
  };
  const selectlassNameForCTA = (variant: string) => {
    switch (variant) {
      case 'topbar-2':
        return `payRentButton2 cp-primary-button-${selectTopBarFacilityDetailsTheme()}`;
      case 'topbar-3':
        return `payRentButton3 cp-primary-button-${selectTopBarFacilityDetailsTheme()} `;
      default:
        return `payRentButton cp-primary-button-${selectTopBarFacilityDetailsTheme()} `;
    }
  };
  const ButtonClass = () => {
    return (
      <Button
        className={
          variant === 'topbar-3'
            ? `buttonDisplay cp-primary-button-dark`
            : `buttonDisplay cp-primary-button-${
                currTheme === 'light' ? 'light' : 'dark'
              }`
        }
      >
        <Link to={url} className={selectlassNameForCTA(variant)}>
          {buttonsConfig.text} &nbsp;
          {locationtype === 'multi' ? (
            <FontAwesomeIcon
              iconClassName={buttonsConfig.iconName}
              iconContextProps={{
                style: {
                  fontSize:
                    variant === 'topbar-2' || variant === 'topar-3'
                      ? HEADER_ICON_SIZES.CTAButtoniconSizeTopBarTwoAndThree
                      : HEADER_ICON_SIZES.CTAButtoniconSize,
                },
              }}
            />
          ) : (
            <FontAwesomeIcon
              iconClassName={buttonsConfig.iconName}
              iconContextProps={{
                style: {
                  fontSize:
                    variant === 'topbar-2' || variant === 'topar-3'
                      ? HEADER_ICON_SIZES.CTAButtoniconSizeTopBarTwoAndThree
                      : HEADER_ICON_SIZES.CTAButtoniconSize,
                },
              }}
            />
          )}
        </Link>
      </Button>
    );
  };
  if (show && showOnTouchDevice) {
    return <ButtonClass />;
  } else if (show && !showOnTouchDevice) {
    return <ButtonClass />;
  } else if (!show && showOnTouchDevice) {
    if (width < desktopscreensize) {
      return <ButtonClass />;
    } else {
      return <></>;
    }
  } else {
    return <></>;
  }
};

export const TopBarFacilityDetailsVariantTwo = (
  contactDetails: TopBarTypes.TContactDetails,
  redirectDetails: TopBarTypes.TRedirectDetails,
  iconsList: TopBarTypes.TIconsList
) => {
  return (
    <div className="topBarHelperTablet">
      {/*for tablet */}
      <CommonFacilityDetailsHelper
        contactDetailsInfo={contactDetails.facilityDetails}
        contactDetails={contactDetails}
        iconsList={iconsList}
        redirectDetails={redirectDetails}
        contactDetailsType="address"
        variantType="topbar-2"
      />
      <CommonFacilityDetailsHelper
        contactDetailsInfo={contactDetails.emailID}
        contactDetails={contactDetails}
        iconsList={iconsList}
        redirectDetails={redirectDetails}
        contactDetailsType="email"
        variantType="topbar-2"
      />
      <CommonFacilityDetailsHelper
        contactDetailsInfo={contactDetails.mailingAddress}
        contactDetails={contactDetails}
        iconsList={iconsList}
        redirectDetails={redirectDetails}
        contactDetailsType="mailingAddress"
        variantType="topbar-2"
      />
      <CommonFacilityDetailsHelper
        contactDetailsInfo={contactDetails.phoneNumber}
        contactDetails={contactDetails}
        iconsList={iconsList}
        redirectDetails={redirectDetails}
        contactDetailsType="phone"
        variantType="topbar-2"
      />
    </div>
  );
};

export const TopBarFacilityDetailsVariantOne = (
  contactDetails: TopBarTypes.TContactDetails,
  redirectDetails: TopBarTypes.TRedirectDetails,
  iconsList: TopBarTypes.TIconsList
) => {
  return (
    <div className="topBarHelperTablet">
      {/*for tablet */}
      <CommonFacilityDetailsHelper
        contactDetailsInfo={contactDetails.facilityDetails}
        contactDetails={contactDetails}
        iconsList={iconsList}
        redirectDetails={redirectDetails}
        contactDetailsType="address"
        variantType="topbar-1"
      />
      <CommonFacilityDetailsHelper
        contactDetailsInfo={contactDetails.emailID}
        contactDetails={contactDetails}
        iconsList={iconsList}
        redirectDetails={redirectDetails}
        contactDetailsType="email"
        variantType="topbar-1"
      />
      <CommonFacilityDetailsHelper
        contactDetailsInfo={contactDetails.phoneNumber}
        contactDetails={contactDetails}
        iconsList={iconsList}
        redirectDetails={redirectDetails}
        contactDetailsType="phone"
        variantType="topbar-1"
      />
    </div>
  );
};

export const TopBarFacilityDetailsVariantThree = (
  contactDetails: TopBarTypes.TContactDetails,
  redirectDetails: TopBarTypes.TRedirectDetails,
  iconsList: TopBarTypes.TIconsList,
  locationtype: TopBarTypes.TLocationTypes,
  buttonsConfig: TopBarTypes.TButtonsConfig,
  variant: string
) => {
  return (
    <div className="topBarHelperTablet">
      {/*for tablet */}
      <CommonFacilityDetailsHelper
        contactDetailsInfo={contactDetails.emailID}
        contactDetails={contactDetails}
        iconsList={iconsList}
        redirectDetails={redirectDetails}
        contactDetailsType="email"
        variantType="topbar-3"
      />
      <CommonFacilityDetailsHelper
        contactDetailsInfo={contactDetails.phoneNumber}
        contactDetails={contactDetails}
        iconsList={iconsList}
        redirectDetails={redirectDetails}
        contactDetailsType="phone"
        variantType="topbar-3"
      />
      <Column className="is-desktop payRentButton3 is-flex is-justify-content-center is-align-items-center">
        {renderPayRentButton(locationtype, buttonsConfig, variant)}
      </Column>
    </div>
  );
};
export const TopBarFacilityDetailsVariantFour = ({
  contactDetails,
  redirectDetails,
  iconsList,
}: TopBarTypes.TTopBarVariantDetails) => {
  return (
    <div className="topBarHelperTablet">
      {/*for tablet */}
      <CommonFacilityDetailsHelper
        contactDetailsInfo={contactDetails.facilityDetails}
        contactDetails={contactDetails}
        iconsList={iconsList}
        redirectDetails={redirectDetails}
        contactDetailsType="address"
        variantType="topbar-4"
      />
      <CommonFacilityDetailsHelper
        contactDetailsInfo={contactDetails.emailID}
        contactDetails={contactDetails}
        iconsList={iconsList}
        redirectDetails={redirectDetails}
        contactDetailsType="email"
        variantType="topbar-4"
      />
      <CommonFacilityDetailsHelper
        contactDetailsInfo={contactDetails.mailingAddress}
        contactDetails={contactDetails}
        iconsList={iconsList}
        redirectDetails={redirectDetails}
        contactDetailsType="mailingAddress"
        variantType="topbar-4"
      />
      <Column className="is-desktop is-flex is-justify-content-center is-align-items-center">
        <>
          <GenericFacilityDetails
            variant="topbar-4"
            facilityDetailsType="phone"
            data={contactDetails.phoneNumber}
            iconsList={iconsList}
            redirectDetails={redirectDetails}
            contactDetails={contactDetails}
          />
        </>
      </Column>
    </div>
  );
};
